var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.data,"items-per-page":+_vm.limit || 5}})}
var staticRenderFns = []

export { render, staticRenderFns }